<template>
  <div id="entry-works" @click="clickAreaFn($event)">
    <div id="occupied"></div>
    <div class="work-content">
      <div class="form-wrap">
        <div class="form_item" @click="showPopup('group')">
          <div class="input">
            <template>
              <p class="placeholder" v-if="!form.group">
                请选择组别
              </p>
              <p class="select-div" v-else>
                {{ groupTypeTxt }}
              </p>
              <!-- <img class="icon-close" src="../assets/images/icon_close.png" /> -->
            </template>

            <van-popup
              v-model="showGroupPop"
              position="bottom"
              :style="{ height: '45%' }"
            >
              <van-picker
                show-toolbar
                value-key="name"
                :columns="groupArr"
                @confirm="confirmGroupPop"
              />
            </van-popup>
          </div>
          <div class="icon-close">
            <img src="../assets/images/btn_arrows.png" />
          </div>
        </div>

        <div class="form_item">
          <div class="input" @click="showPopup('province')">
            <template>
              <p class="placeholder" v-if="!form.province">
                请选择省份
              </p>
              <p class="select-div" v-else>
                {{ provinceValue.name }}
              </p>
            </template>

            <van-popup
              v-model="showProvincePop"
              position="bottom"
              :style="{ height: '45%' }"
            >
              <van-picker
                show-toolbar
                value-key="name"
                :columns="provinceArr"
                @confirm="confirmProvincePop"
              />
            </van-popup>
          </div>
          <div class="icon-close" @click="clearData('province')">
            <img src="../assets/images/btn_close.png" />
          </div>
        </div>

        <div class="form_item">
          <div class="input" @click="showPopup('city')">
            <template>
              <p class="placeholder" v-if="!form.city">
                请选择城市
              </p>
              <p class="select-div" v-else>
                {{ cityValue.name }}
              </p>
            </template>

            <van-popup
              v-model="showCityPop"
              position="bottom"
              :style="{ height: '45%' }"
            >
              <van-picker
                show-toolbar
                value-key="name"
                :columns="cityArr"
                @confirm="confirmCityPop"
              />
            </van-popup>
          </div>
          <div class="icon-close" @click="clearData('city')">
            <img src="../assets/images/btn_close.png" />
          </div>
        </div>

        <div class="form_item">
          <div class="input" @click="showPopup('school')">
            <template>
              <p class="placeholder" v-if="!form.school">
                请选择学校
              </p>
              <p class="select-div" v-else>
                {{ schoolValue.name }}
              </p>
            </template>

            <van-popup
              v-model="showSchoolPop"
              position="top"
              :style="{ height: '45%' }"
            >
              <div class="search-bar">
                <input
                  class="search-input"
                  id="school"
                  type="text"
                  name="school"
                  v-model="schoolKeyWord"
                  @input="searchSchool"
                  placeholder="请输入搜索关键词"
                />
              </div>
              <van-picker
                show-toolbar
                value-key="name"
                :columns="schoolArr"
                @confirm="confirmSchoolPop"
              />
            </van-popup>
          </div>
          <div class="icon-close" @click="clearData('school')">
            <img src="../assets/images/btn_close.png" />
          </div>
        </div>
      </div>
    </div>
    <div class="label-choose">
      <ul class="box">
        <li
          v-for="(tab, index) in tabArr"
          :key="index"
          :class="{ checked: tab.name == rankingType }"
          @click="changeTab(tab.name)"
        >
          {{ tab.title }}
          <i :class="{ checked: tab.name == rankingType }"></i>
        </li>
      </ul>
    </div>
    <div class="form_item uin-bar">
      <input
        class="input"
        id="uid"
        type="number"
        name="uid"
        v-model="uid"
        placeholder="请输入迷你号"
      />
      <div class="icon-search" @click="searchUid">
        <img src="../assets/images/icon_search.png" />
      </div>
    </div>
    <ClassifyWork
      :rankingType="rankingType"
      :form="form"
      :uid="queryUid"
    ></ClassifyWork>
  </div>
</template>

<script>
import { divisionIdM, divisionIdG } from '../common/argumentId';
import ClassifyWork from '../components/entryWorks';
export default {
  name: 'emtryWorks',
  components: {
    ClassifyWork
  },
  data() {
    return {
      showGroupPop: false,
      showProvincePop: false,
      showCityPop: false,
      showSchoolPop: false,
      provinceValue: {},
      cityValue: {},
      schoolValue: {},
      provinceArr: [],
      cityArr: [],
      schoolArr: [],
      schoolKeyWord: '',
      groupTypeTxt: '游戏制作组',
      groupArr: [
        { id: divisionIdM, name: '游戏制作组' },
        { id: divisionIdG, name: '模型制作组' }
      ],
      form: {
        group: '50',
        province: '',
        city: '',
        school: ''
      },
      uid: '',
      queryUid: '',
      rankingType: 'normal',
      tabArr: [
        { title: '入围作品', name: 'finalist' },
        { title: '投稿作品', name: 'normal' },
        { title: '热门作品', name: 'thumbUp' },
        { title: '最新作品', name: 'newest' }
      ]
    };
  },
  mounted() {
    window.sessionStorage.setItem(
      'pathName',
      window.location.hash.split('#')[1]
    );
    this.$scroll('occupied');
    this.queryProvince();
  },
  methods: {
    searchUid() {
      this.queryUid = this.uid;
    },
    changeTab(name) {
      this.rankingType = name;
    },
    // 查询省
    async queryProvince() {
      try {
        const res = await this.$http.apiProvince();
        if (res.data.data && res.data.data.length) {
          res.data.data.forEach(item => {
            this.provinceArr.push({
              name: item.name,
              provinceId: item.provinceId
            });
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 查询市
    async queryCity(pid) {
      this.cityArr = [];
      try {
        const res = await this.$http.apiCity({ pid });
        if (res.data.data && res.data.data.length) {
          res.data.data.forEach(item => {
            this.cityArr.push({
              name: item.name,
              cityId: item.cityId
            });
          });
        }
      } catch (error) {
        console.log(error);
      }
    },
    //  查学校
    async querySchool(val) {
      if (val) {
        try {
          const res = await this.$http.apiSchool({
            provinceId: this.form.province,
            cityId: this.form.city,
            type: 3,
            name: val
          });
          const { data } = res.data;
          this.schoolArr = res.data.data;
          if (data.length) {
            this.schoolArr = res.data.data;
          } else {
            this.schoolArr = [
              {
                id: 'no',
                name: '暂无数据',
                disabled: true
              }
            ];
          }
        } catch (error) {
          console.log(error);
        }
      }
    },
    // 显示选择面板
    showPopup(val) {
      if (val === 'group') {
        this.showGroupPop = true;
      }
      if (val === 'province') {
        if (this.provinceArr.length) {
          this.showProvincePop = true;
        } else {
          this.$Toast('暂无数据');
        }
      }
      if (val === 'city') {
        this.form.province
          ? (this.showCityPop = true)
          : this.$Toast('请先选择省份');
      }
      if (val === 'school') {
        if (!this.form.province || !this.form.city) {
          this.$Toast('请先选择省份和城市');
        } else {
          this.showSchoolPop = true;
        }
      }
    },
    confirmGroupPop(val) {
      this.form.group = val.id;
      val.id == 50
        ? (this.groupTypeTxt = '游戏制作组')
        : (this.groupTypeTxt = '模型制作组');
    },
    // 确认省选择
    confirmProvincePop(val) {
      this.form.province = val.provinceId;
      this.provinceValue = {
        name: val.name,
        provinceId: val.provinceId
      };
      // 查询对应的市 清空城市学校
      this.form.city = '';
      this.queryCity(this.form.province);
      this.form.school = '';
      this.schoolKeyWord = '';
      this.schoolArr = [];
      this.schoolValue = {
        name: '',
        schoolId: ''
      };
    },
    // 确认市选择
    confirmCityPop(val) {
      this.form.city = val.cityId;
      this.cityValue = {
        name: val.name,
        cityId: val.cityId
      };
      this.form.school = '';
      this.schoolKeyWord = '';
      this.schoolArr = [];
      this.schoolValue = {
        name: '',
        schoolId: ''
      };
    },
    // 搜索学校
    searchSchool() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.querySchool(this.schoolKeyWord);
      }, 300);
    },
    // 确认学校选择
    confirmSchoolPop(val) {
      if (val && val.id !== 'no') {
        this.form.school = val.id;
        this.schoolKeyWord = val.name;
        this.schoolValue = {
          name: val.name,
          schoolId: val.id
        };
      }
    },
    // 关闭面板
    clickAreaFn(e) {
      let targets1 = 'van-picker__confirm'; // 确认
      let targets2 = 'van-picker__cancel'; // 取消
      let targets3 = 'van-overlay van-fade-enter van-fade-enter-active'; // 面板外
      if (
        e.target.className == targets1 ||
        e.target.className == targets2 ||
        e.target.className == targets3
      ) {
        this.showProvincePop = false;
        this.showCityPop = false;
        this.showSchoolPop = false;
        this.showGroupPop = false;
        this.schoolKeyWord = '';
      }
    },
    clearData(val) {
      if (val == 'province') {
        this.form.province = '';
        this.form.city = '';
        this.form.school = '';
        this.provinceValue = {};
        this.cityValue = {};
        this.schoolValue = {};
        this.cityArr = [];
        this.schoolArr = [];
        this.schoolKeyWord = '';
      }
      if (val == 'city') {
        this.form.city = '';
        this.form.school = '';
        this.cityValue = {};
        this.schoolValue = {};
        this.schoolArr = [];
        this.schoolKeyWord = '';
      }
      if (val == 'school') {
        this.form.school = '';
        this.schoolValue = {};
        this.schoolArr = [];
        this.schoolKeyWord = '';
      }
    }
    // changeTab(name) {
    //   this.$Toast(name);
    // }
  }
};
</script>

<style lang="scss" scoped>
#entry-works {
  width: 750px;
  padding: 20px;
  .form-wrap {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    .form_item {
      width: 320px;
      margin-bottom: 20px;
      display: flex;
      align-items: center;

      .icon-close {
        width: 60px;
        height: 60px;
        // font-size: 40px;
        color: #ff874b;
        background: #eee;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 30px;
          height: 30px;
        }
      }
    }
  }
  /deep/ .van-picker-column,
  /deep/ .van-picker__cancel,
  /deep/ .van-picker__title,
  /deep/ .van-picker__confirm {
    font-size: 34px;
  }
  /deep/ .van-picker__toolbar {
    height: 70px;
  }
  .input {
    font-size: 26px;
    height: 60px;
    width: 320px;
    border-radius: 4px;
    outline: none;
    background: #eee;
    text-indent: 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    // 选中省市
    .select-div {
      line-height: 60px;
    }
  }
  .uin-bar {
    display: flex;
    align-items: center;
    .input {
      width: 260px;
    }
    .icon-search {
      width: 60px;
      height: 60px;
      background-color: #eeeeee;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 35px;
        height: 35px;
      }
    }
  }
  .label-choose {
    width: 100%;
    margin-bottom: 20px;
    ul {
      width: 100%;
      font-weight: 600;
      font-size: 30px;
      li {
        width: 25%;
        height: 50px;
        display: inline-block;
        text-align: center;
        line-height: 50px;
        padding: 0 20px;
      }
      i {
        display: none;
      }
      i.checked {
        display: block;
        width: 100%;
        height: 5px;
        background-color: #ff874b;
      }
    }
  }
  // div的placeholder
  .input:empty::before {
    line-height: 60px;
    color: #ccc;
    content: attr(placeholder);
  }
  input::-webkit-input-placeholder {
    /* WebKit browsers */
    color: #ccc;
  }
  input:-moz-placeholder {
    /* Mozilla Firefox 4 to 18 */
    color: #ccc;
  }
  input::-moz-placeholder {
    /* Mozilla Firefox 19+ */
    color: #ccc;
  }
  input:-ms-input-placeholder {
    /* Internet Explorer 10+ */
    color: #ccc;
  }
  .placeholder {
    line-height: 60px;
    color: #ccc;
  }
  .search-bar {
    font-size: 28px;
    height: 100px;
    width: 100%;
    display: flex;
    justify-content: space-around;
    .search-input {
      width: 100%;
      text-indent: 30px;
      border: 1px solid #ff874b;
      color: #ff874b;
    }
  }
}
</style>
